import React from 'react';
import { Space } from 'antd';
import { EpcEstimateProjectCostStrip } from './EpcEstimateProjectCostStrip';
import type { Est3ProjectCostLeafKey } from './est3ProjectCostBuckets';
import type { Wave5Ctx } from './EpcEstimateWave5Panels';

export interface EpcEstimateProjectCostLeafProps {
  ctx: Wave5Ctx;
  leaf: Est3ProjectCostLeafKey;
  children: React.ReactNode;
}

/**
 * EST3 UX2 Wave 7 — Project cost leaf wrapper (TEC strip + panel).
 */
export const EpcEstimateProjectCostLeaf: React.FC<EpcEstimateProjectCostLeafProps> = ({
  ctx,
  leaf,
  children,
}) => (
  <Space direction="vertical" style={{ width: '100%' }} size="middle">
    <EpcEstimateProjectCostStrip ctx={ctx} activeLeaf={leaf} />
    {children}
  </Space>
);
